import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { TagContextProvider } from '../../utils/tag.context';

import * as styles from './tag.styles';

export type TagVariant = 'default' | 'highlight' | 'success' | 'warning' | 'error';

export type TagSize = 'medium' | 'small';

type Props = {
  children: ReactNode;
  size?: TagSize;
  variant?: TagVariant;
  className?: string;
  fitContent?: boolean;
};

export const Tag = ({
  size = 'medium',
  variant = 'default',
  fitContent = false,
  children,
  className,
  ...rest
}: Props) => {
  const theme = useTheme();

  return (
    <TagContextProvider size={size} variant={variant}>
      <div
        className={className}
        css={[
          styles.container(theme),
          styles.containerSize(theme)[size],
          styles.background[variant](theme),
          fitContent && styles.fitContent,
        ]}
        data-testid="tag"
        {...rest}>
        {children}
      </div>
    </TagContextProvider>
  );
};
